const reducerCreator = (type, struct) =>
  (state = struct, action = { type: '', payload: struct }) => {
    switch (action.type) {
      case `${type}_SUCCESS`:
        return action.payload
      case `${type}_FAIL`:
        return state
      default:
        return state
    }
  }

const initialState = struct => ({ status: 'idle', state: struct })

export const statusReducer = (type, struct) =>
  (state = initialState(struct), action = { type: '', payload: struct }) => {
    switch (action.type) {
      case `${type}_LOADING`:
        return { ...state, status: 'loading' }
      case `${type}_SUCCESS`:
        return { ...state, status: 'succeeded', state: action.payload }
      case `${type}_FAIL`:
        return { ...state, status: 'failed' }
      default:
        return state
    }
  }

export default reducerCreator